module.exports = __webpack_public_path__ + "static/img/1056_big.357a979.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1056_big.png
// module id = ekZB
// module chunks = 1